/**
 * 
 */
<template>
  <div>
    <el-button size="small" type="primary" class="title mb20" @click="addForm()"
      >新增</el-button
    >
    <el-table
      size="small"
      :data="categoryList"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
      height="78vh"
    >
      <el-table-column
        align="center"
        prop="CommodityTypePicURL"
        label="图片"
        min-width="320px"
      >
        <template slot-scope="scope">
          <el-image
            style="width: 300px; height: 180px"
            :src="bannerUrl  + scope.row.CommodityTypePicURL"
            alt=""
          />
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="CommodityTypeName"
        label="类别名称"
      ></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="text"
            @click="handleFrozen(scope.$index, scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑界面 -->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      width="60%"
      @close="closeDialog()"
    >
      <el-form
        label-width="120px"
        ref="activeForm"
        :rules="rules"
        :model="activeForm"
      >
        <el-form-item label="类别名称" prop="CommodityTypeName">
          <el-input
            v-model="activeForm.CommodityTypeName"
            maxlength="10"
            placeholder="不超过10个字"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <mupload
            :fileList="fileList"
            FilePath="images/Category"
            uploadName="upload"
            :canUpload="true"
            @handleUpload="handleUpload"
            @handleRemove="handleRemoveFile"
          ></mupload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editFormVisible = false"
          >取消</el-button
        >
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('activeForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import mupload from "@/components/upload.vue";
let flag = true;
export default {
  components: { mupload },
  data() {
    return {
      editFormVisible: false,
      loading: false,
      categoryList: [],
      fileList: [],
      bannerUrl: this.$Url+ 'Category/',
      rules: {
        CommodityTypeName: [
          { required: true, message: "请输入类别名称", trigger: "blur" },
          { min: 1, max: 10, message: "长度不超过10个字符", trigger: "blur" },
        ],
      },
      activeForm: {},
      activeIndex: 0,
      personInfo: {},
    };
  },
  mounted() {
    this.personInfo = JSON.parse(this.$util.getStore("personInfo"));
    this.getCategoryList();
  },
  methods: {
    getCategoryList() {
      let categoryList = [];
      let personInfo = this.personInfo;
      let sqlCmdName = "ShopWebApp\\GetCommodityTypeList_1_0_1";
      let data = {
        CompanyGUID: personInfo.CompanyGUID,
      };
      this.loading = true;

      this.$api.QueryDataFn(sqlCmdName + "&DBC=r_m", data).then((res) => {
        let result = res.data;
        if (result.OK != "True") {
          this.$message(result.Message);
        } else if (result.Tag.length == 0) {
        } else {
          categoryList = result.Tag[0].Table;
        }
        this.categoryList = categoryList;
        this.loading = false;
      });
    },
    handleUpload(e) {
      console.log(e, 444);
      this.fileList = [e];
      this.activeForm.CommodityTypePicURL = e.name;
    },
    handleRemoveFile(e) {
      console.log(e, 30444);
      this.fileList = [];
      this.activeForm.CommodityTypePicURL = "";
    },
    addForm() {
      this.activeForm = {};
      this.fileList = []
      this.editFormVisible = true;
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      console.log(index, row);
      this.activeForm = row;
      if (row.CommodityTypePicURL) {
        let obj = {
          url: this.bannerUrl + row.CommodityTypePicURL,
          name: row.CommodityTypePicURL,
        };
        this.fileList = [obj];
      }
      this.editFormVisible = true;
    },
    //显示冻结界面
    handleFrozen: function (index, row) {
      console.log(index, row, 93);
      this.$confirm("确定删除【活动名称】吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // this.$message({
          //   type: "success",
          //   message: "操作成功!",
          // });
          this.delTap(row.CommodityTypeGUID);
        })
        .catch(() => {
          this.$confirm("操作失败，xxx", "", {
            confirmButtonText: "复制错误信息",
            cancelButtonText: "关闭",
            type: "warning",
          }).then(() => {
            console.log(107777);
          });
        });
    },

    delTap: function (guid) {
      let data = [
        {
          CommodityTypeGUID: guid,
          CompanyGUID: this.personInfo.CompanyGUID,
        },
      ];
      this.$loading();
      this.$api
        .ExSqlFn("ShopWebApp\\DeleteCommodityType_1_0_1&DBC=w_m", data)
        .then((res) => {
          this.$loading().close();
          let result = res.data;
          if (result.OK != "True") {
            this.$message(result.Message);
          } else if (result.Tag.length == 0) {
            this.$message("提交资讯信息失败");
          } else {
            this.getCategoryList();
          }
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitTap();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    submitTap: function () {
      let { categoryGuid } = this.activeForm,
        transactionName = "";
      if (categoryGuid == "") {
        transactionName = "发布专场";
        this.$api.returnGuid().then((newCategoryGuid) => {
          this.submitData(newCategoryGuid, transactionName);
        });
      } else {
        transactionName = "修改专场";
        this.submitData(categoryGuid, transactionName, 1);
      }
    },
    submitData(categoryGuid, transactionName) {
      let { CommodityTypeName, CommodityTypePicURL } = this.activeForm;
      let { personInfo } = this;
      let Parameter1 = [
        {
          CommodityTypeGUID: categoryGuid ,
          CommodityTypeName: CommodityTypeName,
          CommodityTypePicURL: CommodityTypePicURL,
          CompanyGUID: personInfo.CompanyGUID,
        },
      ];
      let Parameter2 = [];

      let data = [
        {
          SqlCmdName: "ShopWebApp\\UpdateCommodityType_1_0_1",
          DBC: "w_m",
          Parameter: JSON.stringify(Parameter1),
        },
        {
          SqlCmdName: "ShopWebApp\\UpdateCommodityTypeCommoditys_1_0_1",
          DBC: "w_m",
          Parameter: JSON.stringify(Parameter2),
        },
      ];

      this.releaseCategory(
        categoryGuid,
        transactionName,
        data
      );
    },
    releaseCategory: function (
      categoryGuid,
      transactionName,
      submitaData
    ) {
      this.$loading();
      this.$api
        .exsqlDistributedUrl(
          "?TransactionName=" + transactionName,
          JSON.stringify(submitaData)
        )
        .then((res) => {
          this.$loading().close();
          let result = res.data;
          if (result.OK != "True") {
            this.$message(result.Message);
          } else if (result.Tag.length == 0) {
            this.$message("提交信息失败");
          } else {
            this.getCategoryList();
            this.editFormVisible = false;
          }
        });
    },
  },
};
</script>

<style>
</style>

 


// WEBPACK FOOTER //
// src/views/shop/addCategorize.vue